import {
  LOCALIZACAO_UNIDADES_FETCH_LOCATIONS,
  LOCALIZACAO_UNIDADES_TOGGLE_LOADING
} from './types'

export const mutations = {
  [LOCALIZACAO_UNIDADES_FETCH_LOCATIONS](state, payload) {
    state.unidades = [...payload]
  },
  [LOCALIZACAO_UNIDADES_TOGGLE_LOADING](state) {
    state.loading = !state.loading
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/localizacao_unidades/mutations.js